import packageJson from '../package.json';

export const minApiVersion: string = '1.0.0';
export const appVersion: string = packageJson.version;

export const appBarHeight: number = 64;
export const navBarHeight: number = 56;

export const productionApiBaseUrl: string = 'https://kfleet-config-api.azurewebsites.net/api';
export const debugApiBaseUrl: string = 'http://localhost:43333/api';